import { Injectable } from '@angular/core';
import {TituloLogoPjus} from "../model/titulo-logo-pjus.model";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TituloLogoPjusService {
  model: TituloLogoPjus;

  constructor() { }

  setTituloLogoPjus(model: TituloLogoPjus) {
    this.model = new TituloLogoPjus(model);
  }
}
